import { render } from "./SiteHeader.vue?vue&type=template&id=3d33392e"
import script from "./SiteHeader.vue?vue&type=script&lang=js"
export * from "./SiteHeader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Trix\\Documents\\manga-corporation-V2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__